import { onChange, highlightErrors, setReadyToSubmit } from '../../actions/login';

class Input extends React.PureComponent {
  constructor(props) {
    super(props);

    this.input = React.createRef();
  }

  onChange = event => {
    event.preventDefault();
    const { actions, name } = this.props;
    const value = event.target.value;
    actions.highlightErrors(!value, name);
    actions.onChange(name, event.target.value);
    actions.setReadyToSubmit(false);
  };

  componentDidUpdate({ globalError }) {
    if (globalError !== this.props.globalError && this.props.name === 'password') {
      this.input.current.focus();
    }
  }

  render() {
    const { autoFocus, label, name, type, value, error } = this.props;

    return (
      <div className="Form-Row">
        {error && (
          <div className="Form-Error">
            <p>{window.Edocat.texts['label.mandatory']}</p>
          </div>
        )}
        <label htmlFor={name}>{label}</label>
        <div className="Form-Input">
          <input
            autoFocus={autoFocus}
            id={name}
            name={name}
            onChange={this.onChange}
            ref={this.input}
            type={type}
            value={value}
          />
          <span className={`Form-Input-Icon Icon-edocatBaseShare Share Jar Module - SDK 3`} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  value: state.login.form[props.name],
  error: state.login.errors[props.name],
  globalError: state.login.error,
});

const mapDispatchToProps = dispatch => ({
  actions: redux.bindActionCreators({ onChange, highlightErrors, setReadyToSubmit }, dispatch),
});

export default reactRedux.connect(mapStateToProps, mapDispatchToProps)(Input);
